module.exports = __webpack_public_path__ + "images/screen-shots/distance_dropoff-68cae8a919fd42aca9cff65bcc2673a5.png";